import axios from 'axios'

export const v2_login = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/login`;
    return axios.post(url,model).then((res) => {
        return res.data;
    })

}